import React from 'react';
import ContactArea from './ContactArea';
import PageEditorWrapper from '../../Foundation/components/PageEditorWrapper';

const SiteDepartments = ({ fields }) => {
  const departments = fields?.departments || [];
  return (
    <>
      <div className="site-page__contacts site-contact-top">
        <h2 className="site-page__contacts-title text-center">Kontakt og åpningstider</h2>
        {departments.map((item, index) => (
          <ContactArea
            key={index}
            brands={item?.brands}
            email={item?.contact?.email}
            phone={item?.contact?.phone}
            name={item?.departmentTypeName}
            openDay={item?.openingSchedule?.day}
            openHours={item?.openingSchedule?.openingHours}
            users={item?.users}
            content={item?.content}
          />
        ))}
      </div>
    </>
  );
};

export default PageEditorWrapper(SiteDepartments);
